<div class="hero-map" (mouseleave)="clearHoveredNode()">
  <aside class="hero-map__card" aria-label="Example innovation question">
    <span class="hero-map__category">{{ challenge().category }}</span>
    <p class="hero-map__question">{{ challenge().question }}</p>
    <div class="hero-map__stats">
      <span
        ><strong>{{ connectedFindings() }}</strong> connected findings</span
      >
      <span class="hero-map__divider" aria-hidden="true"></span>
      <span
        ><strong>{{ totalConnections() }}</strong> connections</span
      >
    </div>
    <div class="hero-map__indicators" aria-label="Choose an innovation question">
      @for (item of challenges; track item.category; let index = $index) {
        <button
          type="button"
          class="hero-map__indicator"
          [class.hero-map__indicator--active]="index === challengeIndex()"
          [attr.aria-label]="item.category"
          [attr.aria-current]="index === challengeIndex() ? 'true' : null"
          (click)="selectChallenge(index)"
        ></button>
      }
    </div>
  </aside>

  <svg
    class="hero-map__graphic"
    [class.hero-map__graphic--switching]="challengeFade()"
    viewBox="0 0 1080 700"
    role="img"
    aria-labelledby="hero-map-title hero-map-description"
  >
    <title id="hero-map-title">Interactive innovation map</title>
    <desc id="hero-map-description">
      {{ challenge().question }} Select a concept to highlight its connected findings.
    </desc>
    <defs>
      <pattern id="hero-map-grid" width="60" height="60" patternUnits="userSpaceOnUse">
        <path class="hero-map__grid-line" d="M 60 0 L 0 0 0 60"></path>
      </pattern>
    </defs>
    <rect width="1080" height="700" fill="url(#hero-map-grid)"></rect>

    <g class="hero-map__edges">
      @for (edge of renderedEdges(); track challengeIndex() + '-' + edge.index) {
        <path
          class="hero-map__edge"
          [class.hero-map__edge--lit]="edge.lit"
          [attr.d]="edge.path"
        ></path>
      }
    </g>

    <g class="hero-map__nodes">
      @for (node of renderedNodes(); track challengeIndex() + '-' + node.id) {
        <g
          class="hero-map__node-group"
          role="button"
          tabindex="0"
          [style.--node-phase]="node.index"
          [attr.aria-label]="'Explore connections for ' + node.id"
          (mouseenter)="hoverNode(node.index)"
          (mouseleave)="clearHoveredNode()"
          (focus)="hoverNode(node.index)"
          (blur)="clearHoveredNode()"
          (click)="selectNode(node.index)"
          (keydown.enter)="selectNode(node.index)"
          (keydown.space)="selectNode(node.index); $event.preventDefault()"
        >
          <circle
            class="hero-map__halo"
            [class.hero-map__halo--visible]="node.focused"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius + 9"
          ></circle>
          <circle
            class="hero-map__node"
            [class.hero-map__node--focused]="node.focused"
            [class.hero-map__node--lit]="node.lit"
            [class.hero-map__node--hub]="node.kind === 'hub'"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius"
          ></circle>
          @if (node.kind === 'hub' || node.focused) {
            <circle
              class="hero-map__node-core"
              [class.hero-map__node-core--focused]="node.focused"
              [attr.cx]="node.x"
              [attr.cy]="node.y"
              [attr.r]="node.radius > 12 ? node.radius - 8 : 4"
            ></circle>
          }
          <text
            class="hero-map__label"
            [class.hero-map__label--lit]="node.lit"
            [class.hero-map__label--hub]="node.kind === 'hub'"
            [class.hero-map__label--focused]="node.focused"
            [attr.x]="node.x"
            [attr.y]="node.y + node.radius + (node.kind === 'hub' ? 20 : 16)"
            [attr.font-size]="node.labelSize"
            text-anchor="middle"
          >
            {{ node.id }}
          </text>
          <circle
            class="hero-map__hit-area"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius + 10"
          ></circle>
        </g>
      }
    </g>
  </svg>
</div>
